import React from 'react'
import {ListItem, UnorderedList, OrderedList} from '@miro-site/core'
import {ListOptions, ListType} from './types'

const LIST_COMPONENTS: Record<
  ListType,
  React.FC<React.ComponentProps<typeof UnorderedList | typeof OrderedList>>
> = {
  bullets: UnorderedList,
  numbers: OrderedList,
}
const ListAdapter: React.FC<ListOptions> = ({list_type = 'bullets', list}) => {
  const ListContainer = LIST_COMPONENTS[list_type]
  return (
    <ListContainer $variant="default">
      {list.map((item, index) => (
        <ListItem key={index}>{item.html}</ListItem>
      ))}
    </ListContainer>
  )
}

export default ListAdapter
